import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {MaterialModule} from './material/material.module';
import { InputFocusDirective } from './input-focus.directive';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BosCommonsModule, TranslateService} from 'bos-commons';
import {RestService} from "./rest/rest.service";
import {ProgressButtonComponent} from './progress-button/progress-button.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    InputFocusDirective,
    ProgressButtonComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    BosCommonsModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  providers: [TranslateService, RestService],
  exports: [MaterialModule, CommonModule, InputFocusDirective, FormsModule, ReactiveFormsModule, BrowserAnimationsModule,ProgressButtonComponent],
})
export class SharedModule {
}
